import { apiRequest } from "@/utils/apiRequest";
import { apiUrl } from "@/utils/apiUrl";

class ProductOrderRepository {
	constructor() {
		const host = window.location.hostname;
		if (host === "localhost" || host.startsWith("192.168")) {
			this.urlBase = process.env.VUE_APP_API_BASE_URL;
		} else {
			this.urlBase = window.location.origin;
		}
	}

	/**
	 * Mark product order(s) as preparing.
	 * @param {string|string[]} productOrderIds - Single ID or array of IDs
	 */
	async markAsPreparingProductOrder(productOrderIds) {
		const ids = Array.isArray(productOrderIds) ? productOrderIds : [productOrderIds];
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/startpreparation"), method: "POST", body: { productOrderIds: ids }, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal marcando el pedido como preparando");
		}
	}

	async toggleMenuIncluded(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/toggle-menu-included"), method: "PATCH", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal cambiando el producto a menú");
		}
	}

	/**
	 * Add product order(s) to hot table.
	 * @param {string|string[]} productOrderIds - Single ID or array of IDs
	 */
	async addProductOrderToHotTable(productOrderIds) {
		const ids = Array.isArray(productOrderIds) ? productOrderIds : [productOrderIds];
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/addtohottable"), method: "POST", body: { productOrderIds: ids }, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal añadiendo a la hot table");
		}
	}

	/**
	 * Remove product order(s) from hot table.
	 * @param {string|string[]} productOrderIds - Single ID or array of IDs
	 */
	async removeProductOrderFromHotTable(productOrderIds) {
		const ids = Array.isArray(productOrderIds) ? productOrderIds : [productOrderIds];
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/removetohottable"), method: "POST", body: { productOrderIds: ids }, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal eliminando de la hot table");
		}
	}

	async finishPreparation(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/finishpreparation"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal finalizando el pedido");
		}
	}

	async serveProductOrders(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/serve"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal sirviendo el pedido");
		}
	}

	async dispatchFireableProductOrders(data) {
		try {
			const response = await apiRequest({ url: apiUrl("/world/api/productorder/dispatch-fireable"), method: "POST", body: data, throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal al marchar el dishClass");
		}
	}

	/**
	 * Fetches the served-history batches from the backend.
	 * @param {number} page - Page number (1-indexed)
	 * @param {number} limit - Number of batches per page
	 * @param {string|null} date - Target date in YYYY-MM-DD format
	 * @param {string|null} before - Cursor for pagination (ISO date string)
	 * @returns {Promise<{batches: Array, page: number, hasMore: boolean}>}
	 */
	async getServedHistory(page = 1, limit = 5, date = null, before = null) {
		let path = `/world/api/product-orders/served-history?page=${page}&limit=${limit}`;
		if (date) {
			path += `&date=${date}`;
		}
		if (before) {
			path += `&before=${encodeURIComponent(before)}`;
		}
		try {
			const response = await apiRequest({ url: apiUrl(path), method: "GET", throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo el historial de servidos");
			return { batches: [], page };
		}
	}

	async getServiceEventsHistory({ date = null, productOrderStatus = 100, limit = 10, before = null, serviceEventStatus = null } = {}) {
		let path = `/world/api/history/service-events?productOrderStatus=${encodeURIComponent(productOrderStatus)}&limit=${limit}`;

		if (date) {
			path += `&date=${encodeURIComponent(date)}`;
		}

		if (before) {
			path += `&before=${encodeURIComponent(before)}`;
		}

		if (serviceEventStatus) {
			path += `&serviceEventStatus=${encodeURIComponent(serviceEventStatus)}`;
		}

		try {
			const response = await apiRequest({ url: apiUrl(path), method: "GET", throwOnNonOk: false });
			if (!response.ok) return response.status;
			return response.data;
		} catch (e) {
			console.log("Ups, algo ha ido mal obteniendo el historial de service events");
			return [];
		}
	}
}

export const productOrderRepository = new ProductOrderRepository();
